<h1>{{ title }}</h1>

<button mat-raised-button color="primary" (click)="download()"><mat-icon>picture_as_pdf</mat-icon> Visualizar</button>
